import React, { useEffect } from "react"
import "../styles/app.scss"
import SiteHeader from "../components/site-header"
import SiteFooter from "./site-footer"
import PageMetadata from "../components/page-metadata"
import { Location } from "@reach/router"

const Layout = ({ children }) => {
  const handleKeydown = event => {
    if (event.keyCode === 9) {
      document.body.classList.add("user-is-tabbing")
    }
  }

  const handleClick = () => {
    document.body.classList.remove("user-is-tabbing")
  }

  useEffect(() => {
    window.addEventListener("keydown", handleKeydown)
    return () => {
      window.removeEventListener("keydown", handleKeydown)
    }
  })

  useEffect(() => {
    window.addEventListener("click", handleClick)
    return () => {
      window.removeEventListener("click", handleClick)
    }
  })

  return (
    <Location>
      {({ location }) => (
        <>
          <PageMetadata template={getPage(location.pathname)} />
          <a className="skip-main" href="#main">
            Skip to main content
          </a>
          <SiteHeader path={location.pathname} hash={location.hash} />
          <span className="anchor" id="main" tabIndex="-1" />
          <main className={`page t__${getPage(location.pathname)}`}>
            {children}
          </main>
          <SiteFooter path={location.pathname} />
        </>
      )}
    </Location>
  )
}

function getPage(pathname) {
  let base = pathname.split("/")
  let lastSegment = base.pop() || base.pop()
  if ((lastSegment === "") | (lastSegment === "eng")) {
    return "home"
  } else {
    return lastSegment
  }
}

export default Layout
